$(window).scroll(function() {
    if ($(this).scrollTop() >= 300) {
        $('#back-to-top').fadeIn(200);
    } else {
        $('#back-to-top').fadeOut(200);
    }
});

function backToTop() {
    $('html, body').animate({
        scrollTop: 0
    }, 500);
}
